module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/bofa@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/bofa@3x.png
// module id = 1156
// module chunks = 0